import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  Account,
  createAccountObject,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { StorageService } from '../services/storage.service';
import { NavController } from '@ionic/angular';
import { SwiperContainer } from 'swiper/element';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { getImagePath } from '../utils/getImagePath';
import { SubscribeService } from '../subscribe.service';
import { getAccount } from '../api/account';

@Component({
  selector: 'app-followed-toolbar',
  templateUrl: './followed-toolbar.component.html',
  styleUrls: ['./followed-toolbar.component.scss'],
})
export class FollowedToolbarComponent implements OnInit {
  @ViewChild('swiper') swiperRef: ElementRef<SwiperContainer>;

  accounts: Account[] = [];

  slideNextIcon = faChevronRight;
  slidePrevIcon = faChevronLeft;

  isLoading: boolean = true;

  constructor(
    private subscribeService: SubscribeService,
    private storageService: StorageService,
    private navCtrl: NavController
  ) {
    subscribeService.subscribeSubject.subscribe(() => {
      this.getSubscribedAccounts();
    });
  }

  ngOnInit() {
    this.getSubscribedAccounts();
  }

  getImage = (filename: string) => getImagePath() + filename;

  goToStage(handle: string) {
    this.navCtrl.navigateForward(handle, { animated: false });
  }

  getSubscribedAccounts = async () => {
    try {
      this.isLoading = true;
      const handles = this.subscribeService.getSubscribedAccountHandles();

      this.accounts = await Promise.all(
        handles.map(
          async (handle) =>
            (this.storageService.getStored('account', handle) as Account) ||
            createAccountObject(await getAccount(handle))
        )
      );

      this.isLoading = false;
    } catch (e) {
      console.error(e);
      this.isLoading = false;
    }
  };

  isDesktop = () => window.innerWidth > 992;
}
